import type { ReactNode, SVGProps } from "react";

export function ArrowTailDownIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="14"
			viewBox="0 0 14 14"
			width="14"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g clipPath="url(#clip0_220_179)">
				<path
					d="M7 2.91675V11.0834"
					stroke="#4D4D4D"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="1.5"
				/>
				<path
					d="M10.5 7.58325L7 11.0833"
					stroke="#4D4D4D"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="1.5"
				/>
				<path
					d="M3.5 7.58325L7 11.0833"
					stroke="#4D4D4D"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="1.5"
				/>
			</g>
			<defs>
				<clipPath id="clip0_220_179">
					<rect fill="white" height="14" width="14" />
				</clipPath>
			</defs>
		</svg>
	);
}
